<ui-section class="dynamic-form-vertical-separator-sample">
  <ui-block width="fill">
    <ui-panel panelTitle="EZ Form - Vertical Separators">

      <div class="separator-picker">
        <div class="separator-picker__intro">
          <h4 class="separator-picker__title">Separator presets</h4>
          <p class="separator-picker__blurb">
            Currently showing: {{ activeModeDescription() }}
          </p>
        </div>

        <div class="separator-picker__options">
          <button
            type="button"
            class="separator-mode"
            [class.separator-mode--active]="modeIsSelected(mode.id)"
            (click)="selectMode(mode.id)"
            *ngFor="let mode of separatorModes; trackBy: trackMode">
            <span class="separator-mode__label">{{ mode.label }}</span>
            <span class="separator-mode__desc">{{ mode.description }}</span>
          </button>
        </div>
      </div>

      <ui-form
        [config]="reviewInputs()"
        [preventWrap]="true"
        containerClass="gap-3 items-center">
      </ui-form>

    </ui-panel>
  </ui-block>
</ui-section>
